<template>
  <v-container>
    <h1>{{ verb }} Subtest Type</h1>
    <v-sheet color="white" elevation="1" class="px-5 mt-4 rounded">
      <v-form
        ref="form"
        v-model="valid"
        lazy-validation
        @submit.prevent="submit"
      >
        <v-row>
          <v-col>
            <v-text-field
              v-model="form.type"
              :counter="60"
              :disabled="loading"
              :rules="rules.type"
              label="Type"
              required
            ></v-text-field>
            <v-btn
              :disabled="!valid"
              :loading="loading"
              color="success"
              class="mt-2"
              type="submit"
            >
              Submit
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-sheet>
  </v-container>
</template>

<script>
import { mapActions } from "vuex";
import SubtestType from "@/services/subtest_type";

export default {
  name: "SubtestType.Form",
  data() {
    return {
      valid: false,
      form: {
        type: ""
      },
      rules: {
        type: [
          v => !!v || "Name is required",
          v =>
            (v.length >= 5 && v.length <= 60) ||
            "Name must be greater than 5 and less then 60",
          v =>
            new RegExp(/^[\w\-\s]+$/i).test(v) ||
            "Name must only contain alphanumeric and whitespace characters"
        ]
      },
      loading: false
    };
  },
  computed: {
    verb() {
      return this.$route.params.id ? "Update" : "Create";
    },
    pastVerb() {
      return `${this.verb}d`;
    },
    dataId() {
      return this.$route.params.id;
    }
  },
  async created() {
    this.setNavbarTitle("Manage Subtest Type");
    if (this.dataId) {
      const subtestType = await SubtestType.find(this.dataId);
      const { type } = subtestType.data.data;
      this.form = { type };
    }
  },
  methods: {
    ...mapActions("drawer", ["setNavbarTitle"]),
    async submit() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        try {
          if (this.dataId) {
            await SubtestType.update(this.dataId, this.form);
          } else {
            await SubtestType.create(this.form);
          }

          this.$snackbar.showMessage({
            content: `Data ${this.pastVerb.toLowerCase()}`,
            variant: "success"
          });
          this.$router.push({ name: "SubtestType.Index" });
        } catch (error) {
          this.loading = false;
        }
      }
    }
  }
};
</script>
